<template>
  <div class="page page__list">
    <div class="filter-bar">
      <span @click="selectYear">
        年份 {{ year }}
        <i class="caret"></i>
      </span>
      <span>
        {{ querytype }}
        <i class="caret"></i>
        <select
          class="filter-item__select"
          v-model="querytype"
          @change="searchMonth"
        >
          <option :value="'部门'">部门</option>
          <option :value="'物料'">物料</option>
          <option :value="'客户'">客户</option>
          <option :value="'人员'">人员</option>
          <option :value="'厂家/品牌'">厂家/品牌</option>
        </select>
      </span>
    </div>
    <div class="canvas-title">{{ title }}趋势图</div>
    <div
      class="canvas-box"
      v-show="result.details && result.details.length > 0"
    >
      <canvas id="myChart" class="myChart"></canvas>
    </div>
    <div class="list-box" v-if="result.details && result.details.length > 0">
      <div class="list-left">
        <div class="list-cell">
          <div class="list-cell__main height-36">
            <div class="list-cell__index"></div>
            <div class="list-cell__toggle text-header">年度计划目标</div>
            <div class="list-cell__toggle text-header">实际</div>
          </div>
        </div>
        <div class="list-cell" v-for="(item, index) in list" :key="index">
          <div
            class="list-cell__main"
            :class="selected == index + 1 ? 'bg-color' : ''"
            @click="open(item, index + 1)"
          >
            <div class="list-cell__index">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="list-cell__content">
              {{ item.plantotal }}
            </div>
            <div class="list-cell__content">
              {{ item.acttotal }}
            </div>
          </div>
        </div>
        <div class="list-cell">
          <div class="list-cell__main" style="padding-left: 20px">
            <div class="list-cell__content text-header">
              {{ sumColumn(list, "plantotal") }}
            </div>
            <div class="list-cell__content text-header">
              {{ sumColumn(list, "acttotal") }}
            </div>
          </div>
        </div>
      </div>
      <div class="list-right">
        <div class="list-cell" :class="querytype == '物料' ? 'width-pro' : 'width-all'">
          <div class="list-cell__main">
            <div
              class="list-cell__toggle text-header"
              v-if="querytype == '部门'"
            >
              部门
            </div>
            <div
              class="list-cell__toggle text-header"
              v-if="querytype == '客户'"
            >
              客户
            </div>
            <div
              class="list-cell__toggle text-header"
              v-if="querytype == '人员'"
            >
              人员
            </div>
            <div
              class="list-cell__toggle text-header"
              v-if="querytype == '物料'"
            >
              物料编号
            </div>
            <div
              class="list-cell__toggle text-header"
              v-if="querytype == '物料'"
            >
              物料名称
            </div>
            <div
              class="list-cell__toggle text-header"
              v-if="querytype == '物料'"
            >
              型号
            </div>
            <div
              class="list-cell__toggle text-header"
              v-if="querytype == '厂家/品牌'"
            >
              厂家/品牌
            </div>
            <div class="list-cell__toggle text-header">达成率%</div>
            <div
              class="text-two-header"
              v-for="month in textArr"
              :key="month + querytype"
            >
              <div class="width-200">
                {{ month }}
              </div>
              <div class="width-200">
                <span class="small-header">计划</span>
                <span class="small-header">实际</span>
                <span class="small-header">达成率</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="list-cell" 
          :class="querytype == '物料' ? 'width-pro' : 'width-all'"
          v-for="(items, index2) in list"
          :key="index2"
        >
          <div
            class="list-cell__main"
            :class="selected == index2 + 1 ? 'bg-color' : ''"
            @click="open(items, index2 + 1)"
          >
            <div class="list-cell__toggle" v-if="querytype == '部门'">
              {{ items.py_dpname }}
            </div>
            <div class="list-cell__toggle" v-if="querytype == '客户'">
              {{ items.pyd_custname }}
            </div>
            <div class="list-cell__toggle" v-if="querytype == '人员'">
              {{ items.py_emname }}
            </div>
            <div class="list-cell__toggle" v-if="querytype == '物料'">
              {{ items.pyd_prodcode }}
            </div>
            <div class="list-cell__toggle" v-if="querytype == '物料'">
              {{ items.pr_detail }}
            </div>
            <div class="list-cell__toggle" v-if="querytype == '物料'">
              {{ items.pr_orispeccode }}
            </div>
            <div class="list-cell__toggle" v-if="querytype == '厂家/品牌'">
              {{ items.pyd_brand }}
            </div>
            <div class="list-cell__toggle">{{ items.achievementrate }}</div>
            <div class="list-cell__toggle color-purple">
              {{ items.planamount1 }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.actamount1 }}
            </div>
            <div class="list-cell__toggle">
              {{ items.achievementrate1 }}
            </div>
            <div class="list-cell__toggle color-purple">
              {{ items.planamount2 }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.actamount2 }}
            </div>
            <div class="list-cell__toggle">
              {{ items.achievementrate2 }}
            </div>
            <div class="list-cell__toggle color-purple">
              {{ items.planamount3 }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.actamount3 }}
            </div>
            <div class="list-cell__toggle">
              {{ items.achievementrate3 }}
            </div>
            <div class="list-cell__toggle color-purple">
              {{ items.planamount4 }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.actamount4 }}
            </div>
            <div class="list-cell__toggle">
              {{ items.achievementrate4 }}
            </div>
            <div class="list-cell__toggle color-purple">
              {{ items.planamount5 }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.actamount5 }}
            </div>
            <div class="list-cell__toggle">
              {{ items.achievementrate5 }}
            </div>
            <div class="list-cell__toggle color-purple">
              {{ items.planamount6 }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.actamount6 }}
            </div>
            <div class="list-cell__toggle">
              {{ items.achievementrate6 }}
            </div>
            <div class="list-cell__toggle color-purple">
              {{ items.planamount7 }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.actamount7 }}
            </div>
            <div class="list-cell__toggle">
              {{ items.achievementrate7 }}
            </div>
            <div class="list-cell__toggle color-purple">
              {{ items.planamount8 }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.actamount8 }}
            </div>
            <div class="list-cell__toggle">
              {{ items.achievementrate8 }}
            </div>
            <div class="list-cell__toggle color-purple">
              {{ items.planamount9 }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.actamount9 }}
            </div>
            <div class="list-cell__toggle">
              {{ items.achievementrate9 }}
            </div>
            <div class="list-cell__toggle color-purple">
              {{ items.planamount10 }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.actamount10 }}
            </div>
            <div class="list-cell__toggle">
              {{ items.achievementrate10 }}
            </div>
            <div class="list-cell__toggle color-purple">
              {{ items.planamount11 }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.actamount11 }}
            </div>
            <div class="list-cell__toggle">
              {{ items.achievementrate11 }}
            </div>
            <div class="list-cell__toggle color-purple">
              {{ items.planamount12 }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.actamount12 }}
            </div>
            <div class="list-cell__toggle">
              {{ items.achievementrate12 }}
            </div>
          </div>
        </div>
        <div class="list-cell" :class="querytype == '物料' ? 'width-pro' : 'width-all'">
          <div class="list-cell__main">
            <div class="list-cell__toggle" v-if="querytype == '部门'"></div>
            <div class="list-cell__toggle" v-if="querytype == '客户'"></div>
            <div class="list-cell__toggle" v-if="querytype == '人员'"></div>
            <div class="list-cell__toggle" v-if="querytype == '物料'"></div>
            <div class="list-cell__toggle" v-if="querytype == '物料'"></div>
            <div class="list-cell__toggle" v-if="querytype == '物料'"></div>
            <div
              class="list-cell__toggle"
              v-if="querytype == '厂家/品牌'"
            ></div>
            <div class="list-cell__toggle text-header">
              <!-- {{ sumColumn(list, "achievementrate") }} -->
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "planamount1") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "actamount1") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "achievementrate1") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "planamount2") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "actamount2") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "achievementrate2") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "planamount3") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "actamount3") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "achievementrate3") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "planamount4") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "actamount4") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "achievementrate4") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "planamount5") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "actamount5") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "achievementrate5") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "planamount6") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "actamount6") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "achievementrate6") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "planamount7") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "actamount7") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "achievementrate7") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "planamount8") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "actamount8") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "achievementrate8") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "planamount9") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "actamount9") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "achievementrate9") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "planamount10") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "actamount10") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "achievementrate10") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "planamount11") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "actamount11") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "achievementrate11") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "planamount12") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "actamount12") }}
            </div>
            <div class="list-cell__toggle text-header">
              {{ sumColumn(list, "achievementrate12") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  data() {
    let year = new Date().getFullYear();

    return {
      result: {},
      list: [],
      items: [],
      textArr: [],
      year,
      opened: -1,
      chart: null,
      title: "",
      currentIndex: "",
      querytype: "部门",
      querytypeObj: {
        部门: "dept",
        物料: "prod",
        客户: "cust",
        人员: "empl",
        "厂家/品牌": "brand",
      },
      selected: 0,
    };
  },

  mounted() {
    this.searchMonth();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    searchMonth() {
      let me = this,
        querytype = me.querytypeObj[me.querytype];
      me.$ajax({
        url: "/api/storage/report/planyear",
        params: {
          year: me.year,
          querytype: querytype,
        },
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          me.initChart(me.deal(me.result.monthitems));
          me.deal2(me.result.details);
        }
      });
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.monthitems));
      }
    },
    initChart(data) {
      var chart = this.chart;

      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });

      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          formatter: (i) =>
            i > -1 && i < 12
              ? [
                  "01月",
                  "02月",
                  "03月",
                  "04月",
                  "05月",
                  "06月",
                  "07月",
                  "08月",
                  "09月",
                  "10月",
                  "11月",
                  "12月",
                ][i]
              : null,
        },
      });
      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "计划金额") {
            return "#2eadf5";
          } else if (val === "实际金额") {
            return "#e44959";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05, // 设置分组间柱子的间距
        });
      if (window.innerWidth < window.innerHeight) {
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }

      chart.interaction("pan");
      chart.render();
    },
    deal(data) {
      let me = this;
      me.textArr = [];
      for (let i = 0; i < 12; i++) {
        me.textArr.push(data[i].text);
      }
      let arr = [
        { index: -1, type: "计划金额", value: 0 },
        { index: 12, type: "计划金额", value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push(
          {
            text: me.textArr[i],
            type: "计划金额",
            index: i,
            value: data[i]?.planamount || 0,
          },
          {
            text: me.textArr[i],
            type: "实际金额",
            index: i,
            value: data[i]?.actamount || 0,
          }
        );
      }
      return arr;
    },
    deal2(data) {
      let me = this;
      me.list = [];
      if (!data || data.length == 0) {
        return null;
      }

      for (let i = 0; i < data.length; i++) {
        let obj = data[i];
        let monthDetail1 = [],
          monthDetail2 = [],
          monthDetail3 = [];
        for (let j = 0; j < 12; j++) {
          monthDetail1.push(obj["planamount" + (j + 1)] || 0);
          monthDetail2.push(obj["actamount" + (j + 1)] || 0);
          monthDetail3.push(obj["achievementrate" + (j + 1)] || 0);
        }
        me.list.push({
          ...data[i],
          monthDetail1: monthDetail1,
          monthDetail2: monthDetail2,
          monthDetail13: monthDetail3,
        });
      }
    },
    open(data, index) {
      this.selected = index;
      if (this.querytype == "厂家/品牌") {
        this.title = data.pyd_brand;
      } else {
        this.title = "";
      }
      this.initChart(this.getChartData(data));
      this.selected = index;
    },
    getChartData(data) {
      let me = this,
        arrary = [
          { index: -1, type: "计划金额", value: 0 },
          { index: 12, type: "计划金额", value: 0 },
        ];
      for (var i = 0; i < 12; i++) {
        arrary.push(
          {
            index: i,
            text: me.textArr[i],
            type: "计划金额",
            value: data.monthDetail1[i],
          },
          {
            index: i,
            text: me.textArr[i],
            type: "实际金额",
            value: data.monthDetail2[i],
          }
        );
      }
      return arrary;
    },
    selectYear() {
      var me = this,
        year = new Date().getFullYear(),
        years = [];
      for (let i = year - 20; i <= year; i++) {
        years.push({
          value: i,
          label: i + "年",
        });
      }
      me.$weui.picker(years, {
        title: "选择年份",
        defaultValue: [year],
        onConfirm: function (r) {
          me.year = r[0].value;
          me.searchMonth();
        },
      });
    },
    // 封装计算数组指定某列合计的方法
    sumColumn(array, column) {
      if (!Array.isArray(array) || typeof column !== "string") {
        return 0;
      }
      return array.reduce(
        (sum, item) => sum + (parseFloat(item[column]) || 0),
        0
      ).toFixed(2);
    },
  },
};
</script>

<style scoped>
.bg-color {
  background: #d1e9fe;
}
.color-purple {
  color: #36b2f1;
}
.color-red {
  color: #e6395a;
}
.page__list {
  background: var(--weui-BG);
}
.canvas-box {
  background: var(--weui-BG);
}
.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}
.canvas-title {
  padding-top: 10px;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  background: var(--weui-BG);
}
.canvas-box {
  /* width: 100%;
  height: 100%; */
  background: var(--weui-BG);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
  display: flex;
  border-bottom: 1px solid #cccccc;
}
.list-left {
  width: 180px;
  display: flex;
  flex-direction: column;
}
.list-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: scroll;
}
.report-item {
  width: calc(100% - 20px);
  height: 30px;
  margin: 0 auto;
  font-size: 13px;
  border-bottom: 1px solid #cccccc;
  line-height: 30px;
  color: var(--weui-FG-0);
  display: flex;
}
.font-bold {
  font-weight: bold;
}
.report-item .report-item-name {
  flex: 2;
  text-align: left;
  padding: 0 2px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.report-item .report-item-year {
  flex: 1;
  text-align: center;
  padding: 0 2px;
}
.report-item .report-item-month {
  flex: 1;
  text-align: center;
  padding: 0 2px;
}

.list-cell {
  background-color: #fff;
  border-top: 1px solid #cccccc;
  border-right: 1px solid #cccccc;
}
.list-left > .list-cell {
  border-left: 1px solid #cccccc;
}
.width-all {
  width: 2550px;
}
.width-pro{
  width: 2675px;
}
.width-customer {
  width: 1800px;
}
.list-cell__main {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}
.height-36 {
  height: 36px !important;
}
.list-cell__index {
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-cell__index span {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-color: #c0c0c0;
}
.list-cell__content {
  width: 80px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #000;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__150 {
  width: 150px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #000;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__toggle {
  width: 100px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.text-header {
  font-weight: bold;
  color: #000 !important;
}

.text-two-header {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-align: center;
}
.width-400 {
  width: 400px;
}
.width-200 {
  width: 200px;
}
.text-two-header > div {
  height: 18px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  border-left: 1px dashed #8b8b8b;
}

.small-header {
  display: inline-block;
  width: 84px;
  height: 18px;
  text-align: center;
  font-size: 12px !important;
  font-weight: bold;
}
.gray {
  /* max-height: 300px;
  overflow-y: auto; */
  background: #f4f4f4;
}
@media screen and (min-width: 500px) {
  .filter-bar {
    padding: 6px 0 2px 0;
  }
  .list-cell__toggle {
    height: 20px;
    line-height: 20px;
  }
  .list-cell__content {
    height: 20px;
    line-height: 20px;
  }
  .list-cell__index span {
    width: 20px;
    height: 20px;
  }
  .list-cell__main {
    padding: 5px 0px;
  }
}
</style>